import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import type { SxProps, Theme } from '@mui/material/styles';
import { AVAILABLE_PERIODS } from './constants';

interface Props {
  value: number;
  onChange: (months: number) => void;
  label?: string;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

export default function PeriodSelector({
  value,
  onChange,
  label = 'AVCS Period',
  size = 'small',
  sx,
}: Props) {
  return (
    <TextField
      select
      size={size}
      label={label}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      sx={[{ minWidth: 120 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      data-testid="period-selector"
    >
      {AVAILABLE_PERIODS.map((months) => (
        <MenuItem key={months} value={months}>
          {months} months
        </MenuItem>
      ))}
    </TextField>
  );
}
